module.exports = __webpack_public_path__ + "catalog/lines/separator/separator.jpg";